export default {"src":"/_next/static/media/icone-aura.e59dcb42.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};